<template>
  <div>
    <QueryFrame
      :add-text="handlePermission('drugUseRemindAdd')?'新增规则':''"
      :count="count"
      :current="page"
      @addNew="addNew"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>商品:</label>
            <lk-input :maxlength="100" placeholder="商品编码、通用名、商品名" class="item" clearable v-model.trim="query.nameMix"></lk-input>
          </div>
          <div class="queryItem">
            <label>门店:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
import remind from '../../services/drugUseRemind';
import mapState from '../../mixins/mapState';
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'drugUseRemindList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      query: {
        name: null,
        storeIdList: null,
      },
      statusList: {
        1: '启用',
        2: '禁用',
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          fixed: 'left',
          minWidth: 58,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 160,
        },
        {
          title: '规则名称',
          key: 'roleName',
          minWidth: 183,
          render: (h, params) => this.renderTooTip(h, 2, params.row.roleName),
        },
        {
          title: '商品编码',
          key: 'serialCode',
          minWidth: 120,
          tooltip: true,
        },
        {
          title: '通用名',
          key: 'approvedName',
          minWidth: 120,
          render: (h, params) => this.renderTooTip(h, 2, params.row.approvedName),
        },
        {
          title: '商品名',
          key: 'goodsName',
          minWidth: 120,
          render: (h, params) => this.renderTooTip(h, 2, params.row.goodsName),
        },
        {
          title: '规格',
          key: 'spec',
          minWidth: 116,
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          minWidth: 120,
          render: (h, params) => this.renderTooTip(h, 2, params.row.manufacturer),
        },
        {
          title: '单位',
          key: 'unit',
          minWidth: 90,
        },
        {
          title: '用药提醒间隔',
          key: 'intervalTimes',
          minWidth: 116,
        },
        {
          title: '创建时间',
          key: 'createTimeStr',
          minWidth: 100,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'statusStr',
          minWidth: 100,
          render: (h, params) => (this.handlePermission('drugUseRemindSetStatus') ? h(
            'lk-switch', {
              props: {
                size: 'large',
                value: params.row.status === 1,
                loading: params.row.loading,
              },
              on: {
                'on-change': (e) => {
                  params.row.loading = true;
                  const statusParams = {
                    id: params.row.id,
                    status: e ? 1 : 2,
                  };
                  remind.setRemindStatusEnable(statusParams).then((responseData) => {
                    params.row.loading = false;
                    if (responseData.data.status === 200) {
                      this.$Message.success(e ? '启用成功' : '禁用成功');
                    } else {
                      this.$Message.error(responseData.data.error || '操作失败');
                    }
                  }).catch((err) => {
                    params.row.loading = false;
                    utils.handleError(err);
                  });
                },
              },
            }, [
              h('span', {
                props: {},
                slot: 'open',

              }, '启用'),
              h('span', {
                props: {},
                slot: 'close',

              }, '禁用'),
            ],
          ) : h('span', params.row.status === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 110,
          render: (h, { row }) => h('div', {
            class: {
              textCenter: true,
            },
          },
          [
            this.handlePermission('drugUseRemindEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({
                    name: 'drugUseRemindEdit',
                    params: {
                      id: row.id,
                    },
                  });
                },
              },
            }, '编辑') : '',
            this.handlePermission('drugUseRemindDelete') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.delete(row.id);
                },
              },
            }, '删除') : '',
          ]),
        },
      ],
      tableData: [],
    };
  },
  methods: {

    handleReset() {
      this.query = {};
    },

    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      remind.getRemindList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          list.forEach((item) => {
            item.statusStr = this.statusList[item.status];
            item.createTimeStr = utils.formatTime(item.createTime) || '-';
          });
          this.tableData.push(...list);
          this.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    delete(id) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除规则？',
        onOk: () => {
          remind.deleteRemind({ id }).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('删除成功');
              this.getData();
            } else {
              this.$Message.error(res.data.error);
            }
          });
        },
      });
    },

    addNew() {
      this.$router.push({ name: 'drugUseRemindAdd' });
    },

    /**
    * renderTooTip 表格超出提示
    * @param {*} h
    * @param {*} lines 最大显示行数
    * @param {*} content 行内容
    */
    renderTooTip(h, lines, content) {
      return h('lk-tooltip', {
        props: { placement: 'bottom', transfer: true },
      }, [
        h('span',
          {
            style: {
              textOverflow: 'ellipsis', whiteSpace: 'normal', overflow: 'hidden', display: '-webkit-box', webkitBoxOrient: 'vertical', webkitLineClamp: `${lines}`,
            },
          }, content),
        h('span', { slot: 'content', style: { whiteSpace: 'normal', wordBreak: 'break-all' } }, content),
      ]);
    },

  },
  created() {
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
</style>
